//ComponentView

//New Concept:
//When React goes to rerender an input, it must have a key. Keys need to all be the same as the previous render, container and child container!
//Otherwise inputs WILL lose focus!

import React, { useState, useEffect, useContext, useRef } from 'react';
import { useParams, useHistory } from 'react-router-dom';
import axios from "axios";
import cloneDeep from 'lodash/cloneDeep';
import { v4 as uuidv4 } from 'uuid';

//Navigation History Context Usage Pt1
import { useNavHistory } from '../common/NavigationHistoryContext';
import { Link, useLocation } from 'react-router-dom';
import BackButton from '../common/BackButton';

//CSS Styles
import flexstyles from '../../css/FlexCss';
import useClasses from '../../ui/useClasses';


import { useSelector, useDispatch } from 'react-redux';
import {
	setCurrentMenuSection,
	setCurrentMenuItem
} from '../../features/mainmenu/mainmenuSlice';

//FlexDocument
import { FlexDocument } from '../Documents/FlexDocument';

//New Error Message
import { NewErrorMessage } from '../../features/error/NewErrorMessage';
import {
	newErrorMessage,
	setErrorTimeout
} from '../../features/error/errormessageSlice';

//Contexts
import { AppContext, AppProvider } from "../Auth/contexts/AppContext";
//Error Context
//*Can be used for success as well!
//Types: ok, warning, danger, neutral
import ErrorMessage from "../common/ErrorMessage";
import { ErrorContext } from '../common/ErrorContext';

//Datetime formatting
import Moment from 'react-moment';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'; //Possibly our new adapter for mui x 7 datetime
import dayjs from 'dayjs'; //Used with new datetimepickers
//Restrict Numbers both float and integer types
import RestrictInputNumber from "../common/RestrictInputNumber";




import Checkbox from '@mui/material/Checkbox';
//import Grid from '@mui/material/Grid';
import Grid from '@mui/material/GridLegacy';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import TextareaAutosize from '@mui/material/TextareaAutosize';

//Icons
import SaveIcon from '@mui/icons-material/Save';
import PendingIcon from '@mui/icons-material/Pending';
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import AddIcon from '@mui/icons-material/Add';
import DeleteIcon from '@mui/icons-material/Delete';

//Buttons
import Button from '@mui/material/Button';

//Datetime Pickers
import TextField from '@mui/material/TextField';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';

//DBAutoComplete
import DBAutoComplete from '../common/DBAutoComplete';

//Printing
import { useReactToPrint } from 'react-to-print';

//Record History
import RecordHistory from '../common/RecordHistory';
import { convertFieldResponseIntoMuiTextFieldProps } from '@mui/x-date-pickers/internals';


/* ##########################  Configuration  ########################## */

//DB
var dbendpoint = process.env.REACT_APP_DB_API4;

//Default Axios Post Options
const defaultpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 11800,
};

//Axios Long Post
const longpostoptions = {
	withCredentials: true,
	withXSRFToken: true,
	crossDomain: true,
	mode: "no-cors",
	timeout: 20000,
};

//Helper Functions
//Have not used sleep just yet - is currently on auto-complete sample
function sleep(delay = 0) {
	return new Promise((resolve) => {
		setTimeout(resolve, delay);
	});
}

//Remove - Useful for completely removing object properties by key. May be used for exports.
function removeProp(obj, key) {
	for (var k in obj) {
		if (k === key) {
			delete obj[key];
			return true;
		} else if (typeof obj[k] === "object") {
			if (removeProp(obj[k], key)) return true;
		}
	}
	return false;
}

//Find Duplicate Example:
//This will short-circuit once some() finds a truthy value.
var values = [
	{ name: 'someName1' },
	{ name: 'someName2' },
	{ name: 'someName4' },
	{ name: 'someName1' }
];

var valueArr = values.map(function (item) { return item.name });
var isDuplicate = valueArr.some(function (item, idx) {
	return valueArr.indexOf(item) !== idx
});
//console.log(isDuplicate);

//Simple Find Duplicates (simple array of values).
const input = [1, 1, 2, 3, 3];
const GetDupeArray = (inputarray) => {
	var results = inputarray.reduce(function (acc, el, i, arr) {
		if (arr.indexOf(el) !== i && acc.indexOf(el) < 0) acc.push(el); return acc;
	}, []);
	return results;
}
const dupearray = GetDupeArray(input);
//console.log("Duplicates2: "+dupearray); // = 1,3 (actual array == [1, 3])

//Find and return all unique values:
const GetUniqueArray = (inputarray) => {
	return inputarray.filter((x, i, a) => a.indexOf(x) === i);
}



const ComponentView = (props) => {
	document.title = "Component";
	const dispatch = useDispatch();
	dispatch(setCurrentMenuSection("Products"));
	dispatch(setCurrentMenuItem("/components"));
	//URL Param for ID
	let { id } = useParams();
	console.log(id);

	let history = useHistory();

	/* App Context */
	/* Allows userperms to be used */
	const appContext = useContext(AppContext);
	const { userPerms, userRole } = appContext;

	/* CSS and Media Queries */
	const classes = useClasses(flexstyles);

	const btnSave = useRef();
	const btnPendingSave = useRef();
	const ToggleSaveBtnStatus = (haspendingsave) => {
		//TRUE: We have pending saves.
		if (haspendingsave) {
			btnSave.current.style.display = "none";
			btnPendingSave.current.style.display = "";
		} else {
			//FALSE: We no longer have pending saves.
			btnSave.current.style.display = "";
			btnPendingSave.current.style.display = "none";
		}
	}

	const location = useLocation();
	const { pushPage, stack } = useNavHistory();
	const lastPushedRef = useRef(null);
	/* ##########################  UseState Variables  ########################## */
	const [state, setState] = useState(location.state?.localstate || {
		//Need to initialize a blank item
		dbreload: true, 		//Use in useEffect to check if we should reload the griditems data. Set to false when we're just updating current view items.
		itemloaded: false, //POSSIBLY MOST IMPORTANT! Using defaultValue on an input causes issues if you try to render before item is loaded.
		pendingupdate: false,
		auditview: false,
		historyavailable: false,
		recordhistory: [],
		historyindex: 0,
		itemdiffs: [],
		itemdata: {
			ID: id,
			Name: "default",
			Cost: 0,
		},
		SomeBooleanDefault: true
	});

	//Some inputs will need to work via refs because we may be restricting some inputs and updating both the input itself and the JS variable
	const itemRefs = useRef({
		CostEl: "",
		PullRateEl: "",
		MarginEl: "",
		PositiveIntegerEl: ""
	})

	//Clone State! We'll get the view from localstate!
	let localstate = Object.assign({}, state);

	function UpdateState(stateobject) {
		setState(stateobject);
	}

	//Error Context
	const errors = useContext(ErrorContext);

	//Ref used for printing
	const printRef = useRef();

	const handlePrint = useReactToPrint({
		contentRef: printRef,
	});

	//Load Item
	function LoadItem() {
		const postdata = {
			ID: localstate.itemdata.ID
		};
		axios.post(dbendpoint + "/components/getitem", postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					localstate.itemdata = res.data.item;

					//Datetime Formatting
					localstate.itemdata.CreateDate = dayjs(localstate.itemdata.CreateDate);
					localstate.itemdata.updated_at = dayjs(localstate.itemdata.updated_at);
					localstate.itemdata.created_at = dayjs(localstate.itemdata.created_at);

					//RECORD HISTORY DROP IN
					if (localstate.itemdata.hasOwnProperty('RecordHistory')) {
						if (localstate.itemdata.RecordHistory) {
							localstate.recordhistory = localstate.itemdata.RecordHistory;
							//Sort by updated_at asc (Change a/b for desc)
							//You can also just comment this if it's not needed.
							// localstate.recordhistory = localstate.recordhistory.sort((a, b) => new Date(a.updated_at) - new Date(b.updated_at));
							if (localstate.recordhistory.length > 0) {
								localstate.historyavailable = true;
							}
						}
					}

					//TO DO - USE TERNARY IN JSX ON localstate.editable instead of all those tedious, individually evalutated ones.

					//Evaluate Editable:
					localstate.editable = false;
					//If user can create and the item is PendingItem, allow a single edit.
					if (localstate.itemdata.PendingItem === 1 && userPerms.createDemoData === 1) {
						localstate.editable = true;
					} else if (userPerms.updateComponent === 1) {
						localstate.editable = true;
					}

					//Cost is always nice to have pre-formatted
					localstate.itemdata.Cost = parseFloat(res.data.item.Cost).toFixed(2);
					
					//Show a warning to the user when they're viewing a deleted item
					if (localstate.itemdata.SoftDelete === 1) {
						dispatch(newErrorMessage({ errmsg: "This is a deleted item.", errshow: true, errtimeout: 30000, errtype: "danger" }));
						dispatch(setErrorTimeout(30000));
					}

					//Navigation History Context Usage Pt3
					//We can save this state in history now that the request is complete. Leave out dbreload and itemloaded. Try!
					pushPage(location.pathname, localstate);
					lastPushedRef.current = {
						pathname: location.pathname,
						localstate: localstate
					};

					localstate.dbreload = false;
					//Set Defaults on first load:
					if (!localstate.itemloaded) {
						localstate.itemdatadefaults = localstate.itemdata;
						localstate.itemloaded = true; //Now allow render
					}
					UpdateState(localstate);
				}
				if (res.data.Status === "Failure") {
					//Failure error
					localstate.dbreload = false;
					UpdateState(localstate);
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 10, errtype: "neutral" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(15));
			}
		});
	}



	useEffect(() => {
		//To Do: On load of item, set title to the serial number.
		document.title = "Component " + localstate.itemdata.Name;
		if (state.dbreload) {
			//Avoid duplicate loads.
			localstate.dbreload = false;
			//Diagnostic:
			console.log("Localstate ID: " + localstate.itemdata.ID);
			LoadItem();
		}
	}, [state]);


	function debounce(func, wait, immediate) {
		var timeout;
		return function () {
			var context = this, args = arguments;
			var later = function () {
				timeout = null;
				if (!immediate) func.apply(context, args);
			};
			var callNow = immediate && !timeout;
			clearTimeout(timeout);
			timeout = setTimeout(later, wait);
			if (callNow) func.apply(context, args);
		};
	};

	const SaveChanges = () => {
		//Hide current errors:
		dispatch(setErrorTimeout(0));

		if (localstate.itemdata.Name.length === 0) {
			dispatch(newErrorMessage({ errmsg: "Component name must have a value.", errshow: true, errtimeout: 15, errtype: "warning" }));
			dispatch(setErrorTimeout(15));
			return;
		}

		let postdata = {
			item: localstate.itemdata
		}
		if (deleteitem) {
			postdata.item.DeleteItem = true;
		}
		axios.post(dbendpoint + "/components/update", postdata, defaultpostoptions).then(res => {
			//API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === "login") {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				//All new API calls should return a status.
				if (res.data.Status === "Success") {
					btnSave.current.style.display = "";
					btnPendingSave.current.style.display = "none";
					//Attempt to replace: btnSave.current.disabled = true;
					localstate.pendingsaves = false;
					localstate.dbreload = true;
					UpdateState(localstate);
					dispatch(newErrorMessage({ errmsg: "Saved successfully.", errshow: true, errtimeout: 15, errtype: "ok" }));
					dispatch(setErrorTimeout(10));
				}
				if (res.data.Status === "Deleted") {
					history.push("/components");
					dispatch(setErrorTimeout(0));
				}
				if (res.data.Status === "Failure") {
					//Failure error
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 15, errtype: "warning" }));
					dispatch(setErrorTimeout(15));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 15, errtype: "warning" }));
				dispatch(setErrorTimeout(15));
			}
		});
	}



	//Changes to item
	const onChangeValue = (event, itemkey) => {
		var oldvalue = localstate.itemdata[itemkey];
		var newvalue = event.target.value;
		if (event.key !== "Tab" &&
			event.key !== "ArrowDown" &&
			event.key !== "ArrowUp" &&
			event.key !== "ShiftLeft" &&
			event.key !== "ShiftRight"
		) {

			if (itemkey === "SomeBoolean") {
				if (event.target.checked) {
					localstate.itemdata.SomeBoolean = 1;
				} else {
					localstate.itemdata.SomeBoolean = 0;
				}
			}

			//Float
			if (itemkey === "Cost" || itemkey === "PullRate" || itemkey === "Margin") {
				if (!oldvalue) {
					oldvalue = "0";
				}
				//A new value from RestrictInputNumber means it will override the input. We'll attempt to place the cursor back where it was. Otherwise, take in new value and do not adjust the input.
				newvalue = RestrictInputNumber(newvalue, oldvalue, event, "float"); //All arguments required. New universal function for all pages. However handle result below.
				if (newvalue) {
					itemRefs.current[itemkey + "El"].value = newvalue;
					localstate.itemdata[itemkey] = newvalue;
					//Attempt to refocus and place cursor at the end of the input - This will require we switch the input to text, then back to number:
					const inputElement = itemRefs.current[itemkey + "El"];
					inputElement.type = 'text';
					inputElement.focus();
					inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
					inputElement.type = 'number';
				} else {
					console.log("No newvalue returned, set value in localstate, but leave input untouched.");
					console.log(parseFloat(event.target.value).toFixed(2));
					localstate.itemdata[itemkey] = parseFloat(event.target.value).toFixed(2);
				}
			}

			//Positive Integer:
			if (itemkey === "PositiveInteger") {
				if (!oldvalue) {
					oldvalue = "0";
				}
				//A new value from RestrictInputNumber means it will override the input. We'll attempt to place the cursor back where it was. Otherwise, take in new value and do not adjust the input.
				newvalue = RestrictInputNumber(newvalue, oldvalue, event, "positiveinteger"); //All arguments required. New universal function for all pages. However handle result below.
				if (newvalue) {
					itemRefs.current[itemkey + "El"].value = newvalue;
					localstate.itemdata[itemkey] = newvalue;
					//Attempt to refocus and place cursor at the end of the input - This will require we switch the input to text, then back to number:
					const inputElement = itemRefs.current[itemkey + "El"];
					inputElement.type = 'text';
					inputElement.focus();
					inputElement.setSelectionRange(inputElement.value.length, inputElement.value.length);
					inputElement.type = 'number';
				} else {
					console.log("No newvalue returned, set value in localstate, but leave input untouched.");
					console.log(parseInt(event.target.value));
					localstate.itemdata[itemkey] = parseInt(event.target.value);
				}
			}

			//All others
			if (itemkey === "Name" || itemkey === "LastName" || itemkey === "Date") {
				localstate.itemdata[itemkey] = newvalue;
			}
			localstate.pendingsaves = true;
			//Old
			// btnSave.current.style.color = "white";
			// btnSave.current.style.backgroundColor = "#01579B";
			btnSave.current.style.display = "none";
			btnPendingSave.current.style.display = "";
			UpdateState(localstate);
		}

	}



	//New method to target what is sent from a datetime picker:
	const onChangeDatetimeValue = (newvalue, itemkey) => {
		localstate.itemdata[itemkey] = newvalue;
		localstate.pendingsaves = true;
		//Old
		// btnSave.current.style.color = "white";
		// btnSave.current.style.backgroundColor = "#01579B";
		ToggleSaveBtnStatus(true);
		UpdateState(localstate);
	}


	//Record History
	const ViewRecordHistory = () => {
		//Initiate record history and load last history item for immediate viewing!
		var historylength = localstate.recordhistory.length;
		//Use length-1 for last index
		localstate.historyindex = historylength - 1;
		//localstate.itemdata = Object.assign({}, localstate.recordhistory[historylength-1]);
		localstate.itemdata = cloneDeep(localstate.recordhistory[historylength - 1]);
		//Diffs
		if ((historylength - 1) !== 0) {
			GetDiffs(localstate.itemdata, localstate.recordhistory[localstate.recordhistory.length - 2]);
		} else {
			//Reset diffs:
			for (let key in localstate.itemdata) {
				localstate.itemdiffs[key] = {};
				localstate.itemdiffs[key].dirty = false;
			}
		}
		//Pre-Formatted currency
		localstate.itemdata.Cost = parseFloat(localstate.recordhistory[localstate.recordhistory.length - 1].Cost).toFixed(2);
		localstate.auditview = true;
		UpdateState(localstate);
	}

	const ViewRecord = (newindex) => {
		//Provision to go back to live view:
		if (newindex === localstate.recordhistory.length) {
			//All out of history records, go back to live
			localstate.dbreload = true;
			localstate.auditview = false;
			localstate.itemloaded = false; //Helps rerender! No kidding. After reload, it'll force rerender contents.
			UpdateState(localstate);
		} else {
			localstate.historyindex = newindex;
			localstate.itemdata = localstate.recordhistory[newindex];
			//Diffs
			localstate.itemdiffs = {};
			if (newindex !== 0) {
				GetDiffs(localstate.itemdata, localstate.recordhistory[newindex - 1]);
			} else {
				//Reset diffs:
				for (let key in localstate.itemdata) {
					localstate.itemdiffs[key] = {};
					localstate.itemdiffs[key].dirty = false;
				}
			}
			//Pre-Formatted currency
			localstate.itemdata.Cost = parseFloat(localstate.itemdata.Cost).toFixed(2);
			UpdateState(localstate);
		}
	}

	const GetDiffs = (currentrecord, previousrecord) => {
		for (let key in currentrecord) {
			localstate.itemdiffs[key] = {};
			if (currentrecord[key] !== previousrecord[key]) {
				localstate.itemdiffs[key].dirty = true;
				//We can also setup some kind of greaterthan / lessthan setup one day. 
				//localstate.itemdiffs[key].greaterthanvalue = something;
			} else {
				localstate.itemdiffs[key].dirty = false;
			}
		}
	}

	const RestoreRecord = () => {
		//Notice: YOU WILL NEED TO MAKE ADJUSTMENTS TO YOUR API TO INCLUDE NESTED RELATIONSHIPS
		//Assuming everything is stored in localstate.itemdata (our traversal of RecordHistory helps this)
		//Let's try to send it right back to our update:
		//Send a flag with our item so our update() api endpoint can make specific adjustments.
		localstate.itemloaded = false; //Forces rerender.
		localstate.itemdata["RestoreRecord"] = 1;
		localstate.auditview = false;

		SaveChanges();
	}

	const GoToComponentsTable = () => {
		history.push('/components');
	}


	const onDBAutoCompleteChange = (newvalue, searchkey) => {
		console.log(newvalue);
		//We can parse results by using keys - this makes the function reusable so we can insert many DBAutoComplete Components
		if (searchkey === "products") {
			localstate.itemdata.ProductID = newvalue.ProductID;
			ToggleSaveBtnStatus(true);
			UpdateState(localstate);

		}

		if (searchkey === "producttypes") {
			localstate.itemdata.ProductType = newvalue.Name;
			ToggleSaveBtnStatus(true);
			UpdateState(localstate);

		}

		if (searchkey === "componenttypes") {
			localstate.itemdata.ComponentType = newvalue.Name;
			ToggleSaveBtnStatus(true);
			UpdateState(localstate);
		}
	}

	//UseState variable controls warning message as well as checked status of Checkbox
	const [deleteitem, setDeleteItem] = useState(false);
	const markForDelete = () => {

		if (!deleteitem) {
			dispatch(newErrorMessage({ errmsg: "Item has been marked for deletion. Click 'Save Changes' to complete deletion.", errshow: true, errtimeout: 30000, errtype: "warning" }));
			dispatch(setErrorTimeout(30000));
			ToggleSaveBtnStatus(true);
		} else {
			dispatch(newErrorMessage({ errmsg: "Deletion cancelled.", errshow: true, errtimeout: 10, errtype: "ok" }));
			dispatch(setErrorTimeout(10));
			ToggleSaveBtnStatus(false);
		}
		setDeleteItem(!deleteitem);
	}


	//Component Nodes

	//Template Specific
	const [validtemplatetag, setValidTemplateTag] = useState(false); //Validates for Add Button
	const [templatetag, setTemplateTag] = useState("");
	const [templatevalue, setTemplateValue] = useState("");


	useEffect(() => {
		ValidateNewTemplateNode();
	}, [templatetag, templatevalue]);


	const ValidateNewTemplateNode = () => {
		//alert(templatetag);
		if (templatetag.length > 0) {
			if (/^\$\{[a-zA-Z]+\}$/.test(templatetag)) {
				setValidTemplateTag(true);
			} else {
				setValidTemplateTag(false);
			}
		} else {
			setValidTemplateTag(false);
		}
	}

	const onChangeTemplateTag = (event) => {
		setTemplateTag(event.target.value);
	}

	const onChangeTemplateValue = (event) => {
		setTemplateValue(event.target.value);
	}

	const AddTemplateNode = () => {
		var postdata = {
			ComponentID: localstate.itemdata.ID,
			NodeType: "template",
			TemplateTag: templatetag,
			TemplateValue: templatevalue,

		}
		axios.post(dbendpoint + "/components/addcomponentnode", postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === 'login') {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				if (res.data.Status === 'Success') {


					localstate.dbreload = true;
					setTemplateTag("");
					setTemplateValue("");
					UpdateState(localstate);
				}
				if (res.data.Status === 'Failure') {
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "warning" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(10));
			}
		});
	}

	//Template Node Changes
	const onChangeCurrentTemplateTag = (event, nodeindex) => {
		localstate.itemdata.templatenodes[nodeindex].TemplateTag = event.target.value;
		localstate.itemdata.templatenodes[nodeindex].AllowChange = true;
		UpdateState(localstate);
	}

	const onChangeCurrentTemplateValue = (event, nodeindex) => {
		localstate.itemdata.templatenodes[nodeindex].TemplateValue = event.target.value;
		localstate.itemdata.templatenodes[nodeindex].AllowChange = true;
		//alert(localstate.itemdata.templatenodes[nodeindex].TemplateValue);
		UpdateState(localstate);
	}





	//Column Component Nodes
	const [validcolumnname, setValidColumnName] = useState(false); //Validates for Add Button
	const [columnkey, setColumnKey] = useState("");
	const [columnvalue, setColumnValue] = useState("");

	useEffect(() => {
		ValidateNewColumnNode();
	}, [columnkey, columnvalue]);


	const ValidateNewColumnNode = () => {
		if (columnkey.length > 0 && columnvalue.length > 0) {
			setValidColumnName(true);
		} else {
			setValidColumnName(false);
		}
	}


	const onChangeColumnKey = (event) => {
		setColumnKey(event.target.value);
	}

	const onChangeColumnValue = (event) => {
		setColumnValue(event.target.value);
	}



	const AddColumnNode = () => {
		var postdata = {
			ComponentID: localstate.itemdata.ID,
			NodeType: "column",
			ColumnKey: columnkey,
			ColumnValue: columnvalue,

		}
		axios.post(dbendpoint + "/components/addcomponentnode", postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === 'login') {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				if (res.data.Status === 'Success') {


					localstate.dbreload = true;
					setColumnKey("");
					setColumnValue("");
					UpdateState(localstate);
				}
				if (res.data.Status === 'Failure') {
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "warning" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(10));
			}
		});
	}

	//Column Node Changes
	const onChangeCurrentColumnKey = (event, nodeindex) => {
		localstate.itemdata.columnnodes[nodeindex].TemplateTag = event.target.value;
		localstate.itemdata.columnnodes[nodeindex].AllowChange = true;
		UpdateState(localstate);
	}

	const onChangeCurrentColumnValue = (event, nodeindex) => {
		localstate.itemdata.columnnodes[nodeindex].TemplateValue = event.target.value;
		localstate.itemdata.columnnodes[nodeindex].AllowChange = true;
		UpdateState(localstate);
	}


	const UpdateComponentNode = (nodeindex, nodetype) => {
		if (nodetype === "column") {
			var postdata = {
				ID: localstate.itemdata.columnnodes[nodeindex].ID,
				ComponentID: localstate.itemdata.columnnodes[nodeindex].ComponentID,
				NodeType: localstate.itemdata.columnnodes[nodeindex].NodeType,
				TemplateTag: localstate.itemdata.columnnodes[nodeindex].TemplateTag,
				TemplateValue: localstate.itemdata.columnnodes[nodeindex].TemplateValue,
				ColumnKey: localstate.itemdata.columnnodes[nodeindex].ColumnKey,
				ColumnValue: localstate.itemdata.columnnodes[nodeindex].ColumnValue,
			}
		}

		if (nodetype === "template") {
			var postdata = {
				ID: localstate.itemdata.templatenodes[nodeindex].ID,
				ComponentID: localstate.itemdata.templatenodes[nodeindex].ComponentID,
				NodeType: localstate.itemdata.templatenodes[nodeindex].NodeType,
				TemplateTag: localstate.itemdata.templatenodes[nodeindex].TemplateTag,
				TemplateValue: localstate.itemdata.templatenodes[nodeindex].TemplateValue,
				ColumnKey: localstate.itemdata.templatenodes[nodeindex].ColumnKey,
				ColumnValue: localstate.itemdata.templatenodes[nodeindex].ColumnValue,
			}
		}
		
		axios.post(dbendpoint + "/components/updatecomponentnode", postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === 'login') {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				if (res.data.Status === 'Success') {


					localstate.dbreload = true;
					// setTemplateTag("");
					// setTemplateValue("");
					UpdateState(localstate);
				}
				if (res.data.Status === 'Failure') {
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "warning" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(10));
			}
		});
	}

	const DeleteComponentNode = (templatenode) => {
		var postdata = {
			ID: templatenode.ID
		}
		axios.post(dbendpoint + "/components/deletecomponentnode", postdata, defaultpostoptions).then(res => {
			//Rule #1: API should be setup to send 200 response with status. Merge paginated requests.
			if (res.status === 200) {
				//If ValidateUser() fails to verify user, it sends back 'login' error. 
				if (res.data.Status === 'login') {
					//Not logged in. Reload page causes redirect to /login
					window.location.reload(false);
				}
				if (res.data.Status === 'Success') {
					localstate.dbreload = true;
					UpdateState(localstate);
				}
				if (res.data.Status === 'Failure') {
					dispatch(newErrorMessage({ errmsg: res.data.message, errshow: true, errtimeout: 5, errtype: "warning" }));
					dispatch(setErrorTimeout(10));
				}
			} else {
				//Non-200 message from server.
				dispatch(newErrorMessage({ errmsg: "Bad response from server.", errshow: true, errtimeout: 5, errtype: "warning" }));
				dispatch(setErrorTimeout(10));
			}
		});
	}



	/* 
																							 
		 _/_/_/        _/_/_/_/       _/      _/       _/_/_/        _/_/_/_/       _/_/_/    
		_/    _/      _/             _/_/    _/       _/    _/      _/             _/    _/   
	   _/_/_/        _/_/_/         _/  _/  _/       _/    _/      _/_/_/         _/_/_/      
	  _/    _/      _/             _/    _/_/       _/    _/      _/             _/    _/     
	 _/    _/      _/_/_/_/       _/      _/       _/_/_/        _/_/_/_/       _/    _/      
																						 
																						 
	  */
	/* ##########################  Render Function  ########################## */
	return (
		<LocalizationProvider dateAdapter={AdapterDayjs}>
			{(localstate.itemloaded) &&
				<div style={{ padding: "8px", textAlign: "center", margin: "auto", marginBottom: "100px", overflow: "auto", maxWidth: "1200px" }} ref={printRef}>

					{/* Standard Page Header with right floated error message space */}
					<div style={{ position: "relative", paddingTop: "5px", minWidth: "750px" }}>
						<div style={{ textAlign: "center" }}>
							<h2>Component {localstate.itemdata.Name}</h2>
						</div>
						{(userPerms.updateComponent === 1) &&
							<Box sx={{ '& button': { m: 1 }, displayPrint: 'none' }}>
								{/* <Button
									className={classes.bluebtn}
									color="primary" variant="contained"
									onClick={() => GoToComponentsTable()}>
									<KeyboardBackspaceIcon sx={{ color: "lightgray" }}></KeyboardBackspaceIcon>&nbsp;Back to Components Table
								</Button> */}
								<BackButton text="Back" defaultbacklink="/components" />
								<Button
									className={(userPerms.updateComponent === 1 && !localstate.auditview) ? classes.bluebtn : classes.hidden}
									color="primary" variant="contained"
									onClick={() => SaveChanges()}
									ref={el => btnSave.current = el}>
									<SaveIcon sx={{ color: "lightgray" }}></SaveIcon>&nbsp;Save Changes
								</Button>
								<Button
									className={(userPerms.updateComponent === 1 || userPerms.createDemoData === 1) && !localstate.auditview ? classes.bluebtn : classes.hidden}
									color="primary" variant="contained"
									style={{ display: "none" }}
									onClick={() => SaveChanges()}
									ref={el => btnPendingSave.current = el}>
									<PendingIcon sx={{ color: "orange" }}></PendingIcon>&nbsp;Save Changes
								</Button>
								<Button
									className={(!localstate.auditview ? classes.bluebtn : classes.hidden)}
									color="primary" variant="contained"
									onClick={() => handlePrint()}>
									Print
								</Button>
								{(localstate.auditview && userPerms.updateComponent && localstate.itemdata.SoftDelete === 0) &&
									<Button
										className={classes.orangebtn}
										color="primary" variant="contained"
										onClick={() => RestoreRecord()}>
										Restore This Record
									</Button>
								}
								{(localstate.itemdata.SoftDelete === 1 && userRole === 'admin') &&
									<Button
										className={classes.orangebtn}
										color="primary" variant="contained"
										onClick={() => RestoreRecord()}>
										Undelete This Record
									</Button>
								}
							</Box>
						}
						<Box sx={{ displayPrint: 'none', height: "26px", display: "block" }}>
							<NewErrorMessage />
						</Box>
					</div>

					{/* LIVE VIEW */}
					{(!localstate.auditview) &&
						<Typography variant="h6">
							<Grid container spacing={0}>
								<div className={classes.itemtableheader} style={{ display: "flex" }}>
									<div style={{ flexGrow: 1 }}>Component Details</div>
									{(userRole === "admin" && localstate.historyavailable) &&
										<div style={{ flexGrow: 1, textAlign: "right", paddingRight: "5px" }}>
											<span className={classes.disabledhoverunit + " " + classes.unselectable} >History: </span>
											{(localstate.recordhistory.length > 0 ? <a className={classes.hoverunit + " " + classes.unselectable} onClick={() => ViewRecordHistory()}>&lt;Prev</a> :
												<a className={classes.disabledhoverunit + " " + classes.unselectable} >Prev &lt;</a>)}
											&nbsp;|&nbsp;
											<a className={classes.disabledhoverunit + " " + classes.unselectable} >Next &gt;</a>
										</div>
									}
								</div>

								<Grid item sm={12} md={6}>
									<div className={classes.flextabledebug}>
										<table className={classes.itemtable}>
											<tbody>
												<tr>
													<td style={{ width: "160px" }}>
														ID
													</td>
													<td>
														<div className={classes.flexitemstaticinput}>
															{localstate.itemdata.ID}
														</div>

													</td>
												</tr>
												<tr>
													<td>
														Name:
													</td>
													<td>
														{(userPerms.updateComponent === 1) &&
															<input className={classes.flexiteminput}
																maxLength="100" //Needs max length
																type="text"
																value={localstate.itemdata.Name}
																onChange={(event) => onChangeValue(event, "Name")}
															/>
														}
														{(userPerms.updateComponent === 0) &&
															<div className={classes.flexitemstaticinput}>
																{localstate.itemdata.Name}
															</div>
														}
													</td>
												</tr>

												<tr>
													<td>
														Product Type:
													</td>
													<td>
														{/* Skus are automatically generated by the import process, however products aren't necessarily assigned. */}
														{/* The old system didn't enforce a sku at all. */}
														{(userPerms.updateComponent === 1) &&

															<DBAutoComplete
																keyedby="ID"
																searchtype="producttypes"
																searchkey="Name"
																//itemindex={index}
																defaultsearchterm={(localstate.itemdata.ProductType ? localstate.itemdata.ProductType : "")}
																limit="100"
																disabled={(userPerms.updateComponent === 1 ? false : true)}
																errors={errors}
																allowadd={false}
																freeSolo={false}
																onDBAutoCompleteChange={onDBAutoCompleteChange}
															/>
														}
														{/* {(userPerms.updateComponent === 0) &&
															<div className={classes.flexitemstaticinput}>
																{localstate.itemdata.product.Name}
															</div>
														} */}


													</td>
												</tr>



												<tr>
													<td>
														Component Type:
													</td>
													<td>
														{/* Skus are automatically generated by the import process, however products aren't necessarily assigned. */}
														{/* The old system didn't enforce a sku at all. */}
														{(userPerms.updateComponent === 1) &&

															<DBAutoComplete
																keyedby="ID"
																searchtype="componenttypes"
																searchkey="Name"
																//itemindex={index}
																defaultsearchterm={(localstate.itemdata.ComponentType ? localstate.itemdata.ComponentType : "")}
																limit="100"
																disabled={((userPerms.updateComponent === 1 && localstate.itemdata.ProductType) ? false : true)}
																producttype={(localstate.itemdata.ProductType ? localstate.itemdata.ProductType : "")}
																errors={errors}
																allowadd={false}
																freeSolo={false}
																onDBAutoCompleteChange={onDBAutoCompleteChange}
															/>
														}
														{/* {(userPerms.updateComponent === 0) &&
															<div className={classes.flexitemstaticinput}>
																{localstate.itemdata.product.Name}
															</div>
														} */}


													</td>
												</tr>



												<tr>
													<td>
														Cost:
													</td>
													<td>
														{(userPerms.updateComponent === 1) &&
															<input className={classes.flexiteminput}
																ref={el => itemRefs.current.CostEl = el}
																type="number"
																step="0.01"
																defaultValue={localstate.itemdata.Cost}
																onKeyUp={(event) => onChangeValue(event, "Cost")}
															/>
														}
														{(userPerms.updateComponent === 0) &&
															<div className={classes.flexitemstaticinput}>
																{localstate.itemdata.Cost}
															</div>
														}
													</td>
												</tr>

												<tr>
													<td>
														Pull Rate:
													</td>
													<td>
														{(userPerms.updateComponent === 1) &&
															<input className={classes.flexiteminput}
																ref={el => itemRefs.current.PullRateEl = el}
																type="number"
																step="0.01"
																defaultValue={localstate.itemdata.PullRate}
																onKeyUp={(event) => onChangeValue(event, "PullRate")}
															/>
														}
														{(userPerms.updateComponent === 0) &&
															<div className={classes.flexitemstaticinput}>
																{localstate.itemdata.PullRate}
															</div>
														}
													</td>
												</tr>

												<tr>
													<td>
														Creation Date:
													</td>
													<td>
														<div className={classes.flexitemstaticinput}>
															{dayjs(localstate.itemdata.created_at).format("MMMM D, YYYY [at] h:mma")}
														</div>
													</td>
												</tr>

												<tr>
													<td>
														Created By:
													</td>
													<td>
														<div className={classes.flexitemstaticinput}>
															{(localstate.itemdata.hasOwnProperty('creationuser') ? (localstate.itemdata.creationuser !== null ? localstate.itemdata.creationuser.firstname + " " + localstate.itemdata.creationuser.lastname : "") : "")}
														</div>
													</td>
												</tr>

												<tr>
													<td>
														Updated At:
													</td>
													<td>
														<div className={classes.flexitemstaticinput}>
															{dayjs(localstate.itemdata.updated_at).format("MMMM D, YYYY [at] h:mma")}
														</div>
													</td>
												</tr>
												<tr>
													<td>
														Updated By:
													</td>
													<td>
														<div className={classes.flexitemstaticinput}>
															{(localstate.itemdata.hasOwnProperty('updateuser') ? (localstate.itemdata.updateuser !== null ? localstate.itemdata.updateuser.firstname + " " + localstate.itemdata.updateuser.lastname : "") : "")}
														</div>
													</td>
												</tr>

												{(localstate.itemdata.RestoredBool === 1) &&
													<tr>
														<td>
															<span style={{ fontWeight: "bold" }}>Restored From:</span>
														</td>
														<td>
															<div className={classes.flexitemstaticinput}>
																{dayjs(localstate.itemdata.RestoredFromDate).format("MMMM D, YYYY [at] h:mma")}
															</div>
														</td>
													</tr>
												}
											</tbody>
										</table>
									</div>
								</Grid>
								<Grid item sm={12} md={6}>
									<div className={classes.flextabledebug}>
										<table className={classes.itemtable}>
											<tbody>
												{(userPerms.deleteDemoData === 1 && localstate.itemdata.SoftDelete === 0) &&
													<tr>
														<td style={{ width: "180px", paddingTop: "8px" }}>
															Delete Component:
														</td>
														<td style={{ verticalAlign: "bottom", paddingBottom: "4px" }}>
															<Checkbox
																checked={deleteitem}
																className={classes.gridcheckbox}
																onClick={() => markForDelete()} />
														</td>
													</tr>
												}
											</tbody>
										</table>
									</div>
								</Grid>


							</Grid>

							{/* //RECORD HISTORY DROP IN */}
							{(localstate.itemdata.RecordHistory) &&
								<RecordHistory
									recordhistory={localstate.recordhistory}
									columns={[
										{ columnname: "Date", dbkey: "updated_at", type: "friendlydate", style: { paddingLeft: "16px" } },
										{ columnname: "Name", dbkey: "Name", type: "text", },
										{ columnname: "Cost", dbkey: "Cost", type: "text", },
										{ columnname: "Pull Rate", dbkey: "PullRate", type: "text", },
										{ columnname: "User", dbkey: "updateuser", type: "user", },
									]}
									historytitle="Component History"
								/>
							}
							



							{/* Template Nodes */}
							<Grid container spacing={0}>
								<div className={classes.itemtableheader} style={{ display: "flex" }}>
									<div style={{ flexGrow: 1 }}>Template Nodes</div>
								</div>

								<Grid item sm={12} md={12}>
									<div className={classes.flextabledebug} style={{ textAlign: "left" }}>
										<span style={{ fontSize: "12px" }}>
											Template nodes can be used in the Listing Builder. The Template Tag is replaced with the Template Value when listings are generated and when this component is applied to the template. When possible, create verbosity levels such as SHORT, MEDIUM, and LONG.
											Template tags should look like this: &#36;&#123;CPUSHORT&#125;, &#36;&#123;CPUMEDIUM&#125;, and &#36;&#123;CPULONG&#125; You can also setup simple key-values for your template such as &#36;&#123;CPUCORES&#125; or &#36;&#123;CPUFREQ&#125;.
										</span><br></br><br></br>

										<table className={classes.itemtable} style={{ width: "100%" }}>
											<thead style={{ display: "table-header-group" }}>
												<tr>
													<td style={{ width: "40px", textAlign: "left" }}>
														&nbsp;
													</td>
													<td style={{ width: "200px", textAlign: "left" }}>
														<span style={{ fontSize: "12px" }}>
															<h3 style={{textDecoration:"underline"}}>Tag</h3>
														</span>
													</td>
													<td style={{ textAlign: "left" }}>
														<span style={{ fontSize: "12px" }}>
															<h3 style={{textDecoration:"underline"}}>Value</h3>
														</span>
													</td>
													<td style={{ width: "30px" }}>

													</td>
												</tr>
											</thead>

											<tbody style={{ display: "table-row-group" }}>
												{(userPerms.updateComponent === 1) &&
													<tr>
														<td style={{ padding: "0px 3px" }}>
															<Button
																role={undefined}
																variant="contained"
																tabIndex={-1}
																disabled={!validtemplatetag}
																sx={{ width: 12, minWidth: 12, padding: "1px 15px" }}
																onClick={AddTemplateNode}
															>
																<AddIcon />
															</Button>
														</td>
														<td style={{ padding: "0px 3px" }}>
															<input className={classes.flexiteminput}
																type="text"
																value={templatetag}
																onChange={(event) => onChangeTemplateTag(event)}
															/>
														</td>
														<td style={{ padding: "0px 3px" }}>
															<TextareaAutosize
																className={classes.flexiteminput}
																value={templatevalue}
																onChange={(event) => onChangeTemplateValue(event)}
															/>
														</td>
														<td>

														</td>
													</tr>
												}


												{(localstate.itemdata.templatenodes && localstate.itemdata.templatenodes.length > 0) &&
													localstate.itemdata.templatenodes.map((templatenode, templatenodeindex) => {

														return (
															<tr key={"tnode" + templatenodeindex}>
																<td style={{ padding: "0px 3px" }}>
																	{(userPerms.updateComponent === 1) &&
																		<Button
																			role={undefined}
																			variant="contained"
																			disabled={!templatenode.AllowChange} //Checks for false or unidentified.
																			sx={{ width: 12, minWidth: 12, padding: "1px 15px" }}
																			onClick={() => UpdateComponentNode(templatenodeindex, "template")}
																		>
																			<SaveIcon />
																		</Button>
																	}

																</td>

																<td style={{ padding: "0px 3px" }}>
																	<input className={classes.flexiteminput}
																		type="text"
																		value={templatenode.TemplateTag}
																		onChange={(event) => onChangeCurrentTemplateTag(event, templatenodeindex)}
																	/>
																</td>
																<td style={{ padding: "0px 3px" }}>
																	<TextareaAutosize
																		className={classes.flexiteminput}
																		value={templatenode.TemplateValue}
																		onChange={(event) => onChangeCurrentTemplateValue(event, templatenodeindex)}
																	/>
																</td>
																<td style={{ verticalAlign: "top" }}>
																	{(userPerms.updateComponent === 1) &&
																		<Button
																			role={undefined}
																			variant="contained"
																			sx={{ width: 12, minWidth: 12, padding: "1px 15px", backgroundColor: "orange" }}
																			onClick={() => DeleteComponentNode(templatenode)}
																		>
																			<DeleteIcon />
																		</Button>
																	}
																</td>
															</tr>
														)

													})

												}
											</tbody>
										</table>
									</div>
								</Grid>
							</Grid>

												<br></br><br></br>


							{/* Column Nodes */}
							<Grid container spacing={0}>
								<div className={classes.itemtableheader} style={{ display: "flex" }}>
									<div style={{ flexGrow: 1 }}>Column Nodes</div>
								</div>

								<Grid item sm={12} md={12}>
									<div className={classes.flextabledebug} style={{ textAlign: "left" }}>
										<span style={{ fontSize: "12px" }}>
											Column nodes can be used in the Listing Builder. This feature lets you declare the column name and column value when the listing builder creates a CSV of values.
										</span><br></br><br></br>

										<table className={classes.itemtable} style={{ width: "100%" }}>
											<thead style={{ display: "table-header-group" }}>
												<tr>
													<td style={{ width: "40px", textAlign: "left" }}>
														&nbsp;
													</td>
													<td style={{ width: "200px", textAlign: "left" }}>
														<span style={{ fontSize: "12px" }}>
															<h3 style={{textDecoration:"underline"}}>Column Name</h3>
														</span>
													</td>
													<td style={{ textAlign: "left" }}>
														<span style={{ fontSize: "12px" }}>
															<h3 style={{textDecoration:"underline"}}>Column Value</h3>
														</span>
													</td>
													<td style={{ width: "30px" }}>

													</td>
												</tr>
											</thead>

											<tbody style={{ display: "table-row-group" }}>
												{(userPerms.updateComponent === 1) &&
													<tr>
														<td style={{ padding: "0px 3px" }}>
															<Button
																role={undefined}
																variant="contained"
																tabIndex={-1}
																disabled={!validcolumnname}
																sx={{ width: 12, minWidth: 12, padding: "1px 15px" }}
																onClick={AddColumnNode}
															>
																<AddIcon />
															</Button>
														</td>
														<td style={{ padding: "0px 3px" }}>
															<input className={classes.flexiteminput}
																type="text"
																value={columnkey}
																onChange={(event) => onChangeColumnKey(event)}
															/>
														</td>
														<td style={{ padding: "0px 3px" }}>
															<TextareaAutosize
																className={classes.flexiteminput}
																value={columnvalue}
																onChange={(event) => onChangeColumnValue(event)}
															/>
														</td>
														<td>

														</td>
													</tr>
												}


												{(localstate.itemdata.columnnodes && localstate.itemdata.columnnodes.length > 0) &&
													localstate.itemdata.columnnodes.map((columnnode, columnnodeindex) => {

														return (
															<tr key={"cnode" + columnnodeindex}>
																<td style={{ padding: "0px 3px" }}>
																	{(userPerms.updateComponent === 1) &&
																		<Button
																			role={undefined}
																			variant="contained"
																			disabled={!columnnode.hasOwnProperty('AllowChange')}
																			sx={{ width: 12, minWidth: 12, padding: "1px 15px" }}
																			onClick={() => UpdateComponentNode(columnnodeindex, "column")}
																		>
																			<SaveIcon />
																		</Button>
																	}

																</td>

																<td style={{ padding: "0px 3px" }}>
																	<input className={classes.flexiteminput}
																		type="text"
																		value={columnnode.ColumnKey}
																		onChange={(event) => onChangeCurrentColumnKey(event, columnnodeindex)}
																	/>
																</td>
																<td style={{ padding: "0px 3px" }}>
																	<TextareaAutosize
																		className={classes.flexiteminput}
																		value={columnnode.ColumnValue}
																		onChange={(event) => onChangeCurrentColumnValue(event, columnnodeindex)}
																	/>
																</td>
																<td style={{ verticalAlign: "top" }}>
																	{(userPerms.updateComponent === 1) &&
																		<Button
																			role={undefined}
																			variant="contained"
																			sx={{ width: 12, minWidth: 12, padding: "1px 15px", backgroundColor: "orange" }}
																			onClick={() => DeleteComponentNode(columnnode)}
																		>
																			<DeleteIcon />
																		</Button>
																	}
																</td>
															</tr>
														)

													})

												}
											</tbody>
										</table>
									</div>
								</Grid>
							</Grid>







						</Typography>
					}

					{/* AUDIT VIEW */}
					{(localstate.auditview) &&
						<Typography variant="h6">
							<Grid container spacing={0}>
								<div className={classes.itemtableheader} style={{ display: "flex" }}>
									<div style={{ flexGrow: 1 }}>Component Details</div>

									<div style={{ flexGrow: 1, textAlign: "right", paddingRight: "5px" }}>
										<span className={classes.disabledhoverunit + " " + classes.unselectable} >History: </span>
										{(localstate.historyindex === 0 ?
											<a className={classes.disabledhoverunit + " " + classes.unselectable} >&lt;Prev</a> :
											<a className={classes.hoverunit + " " + classes.unselectable} onClick={() => ViewRecord(localstate.historyindex - 1)}>&lt;Prev</a>
										)}

										&nbsp;|&nbsp;

										{(localstate.historyindex < localstate.recordhistory.length ?
											<a className={classes.hoverunit + " " + classes.unselectable} onClick={() => ViewRecord(localstate.historyindex + 1)}>Next &gt;</a> :
											<a className={classes.disabledhoverunit + " " + classes.unselectable} >Next &gt;</a>
										)}


									</div>

								</div>
								<Grid item sm={12} md={6}>
									<div className={classes.flextabledebug}>
										<table className={classes.itemtable}>
											<tbody>
												<tr>
													<td style={{ width: "180px" }}>
														ID
													</td>
													<td>
														<div className={classes.flexitemstaticinput}>
															{localstate.itemdata.ID}
														</div>

													</td>
												</tr>
												<tr>
													<td>
														Name:
													</td>
													<td>
														<div className={classes.flexitemstaticinput + (localstate.itemdiffs.Name.dirty ? " " + classes.unsavedhighlight : "")}>
															{localstate.itemdata.Name}
														</div>
													</td>
												</tr>
												<tr>
													<td>
														Product Type:
													</td>
													<td>
														<div className={classes.flexitemstaticinput + (localstate.itemdiffs.ProductType.dirty ? " " + classes.unsavedhighlight : "")}>
															{localstate.itemdata.ProductType}
														</div>
													</td>
												</tr>
												<tr>
													<td>
														Component Type:
													</td>
													<td>
														<div className={classes.flexitemstaticinput + (localstate.itemdiffs.ComponentType.dirty ? " " + classes.unsavedhighlight : "")}>
															{localstate.itemdata.ComponentType}
														</div>
													</td>
												</tr>
												<tr>
													<td>
														Cost:
													</td>
													<td>
														<div className={classes.flexitemstaticinput + (localstate.itemdiffs.Cost.dirty ? " " + classes.unsavedhighlight : "")}>
															{localstate.itemdata.Cost}
														</div>
													</td>
												</tr>
												<tr>
													<td>
														Pull Rate:
													</td>
													<td>
														<div className={classes.flexitemstaticinput + (localstate.itemdiffs.PullRate.dirty ? " " + classes.unsavedhighlight : "")}>
															{localstate.itemdata.PullRate}
														</div>
													</td>
												</tr>

												<tr>
													<td>
														Creation Date:
													</td>
													<td>
														<div className={classes.flexitemstaticinput + (localstate.itemdiffs.created_at.dirty ? " " + classes.unsavedhighlight : "")}>
															{dayjs(localstate.itemdata.created_at).format("MMMM D, YYYY [at] h:mma")}
														</div>
													</td>
												</tr>
												<tr>
													<td>
														Created By:
													</td>
													<td>
														<div className={classes.flexitemstaticinput}>
															{(localstate.itemdata.hasOwnProperty('creationuser') ? (localstate.itemdata.creationuser !== null ? localstate.itemdata.creationuser.firstname + " " + localstate.itemdata.creationuser.lastname : "") : "")}
														</div>
													</td>
												</tr>
												<tr>
													<td>
														Updated At:
													</td>
													<td>
														<div className={classes.flexitemstaticinput + (localstate.itemdiffs.updated_at.dirty ? " " + classes.unsavedhighlight : "")}>
															{dayjs(localstate.itemdata.updated_at).format("MMMM D, YYYY [at] h:mma")}
														</div>
													</td>
												</tr>
												<tr>
													<td>
														Updated By:
													</td>
													<td>
														<div className={classes.flexitemstaticinput + " " + classes.unsavedhighlight}>
															{(localstate.itemdata.hasOwnProperty('updateuser') ? (localstate.itemdata.updateuser !== null ? localstate.itemdata.updateuser.firstname + " " + localstate.itemdata.updateuser.lastname : "") : "")}
														</div>
													</td>
												</tr>


												{(localstate.itemdata.RestoredBool === 1) &&
													<tr>
														<td>
															<span style={{ fontWeight: "bold" }}>Restored From:</span>
														</td>
														<td>
															<div className={classes.flexitemstaticinput + (localstate.itemdiffs.RestoredFromDate.dirty ? " " + classes.unsavedhighlight : "")}>
																{dayjs(localstate.itemdata.RestoredFromDate).format("MMMM D, YYYY [at] h:mma")}
															</div>
														</td>
													</tr>
												}
											</tbody>
										</table>
									</div>
								</Grid>
								<Grid item sm={12} md={6}>
									<div className={classes.flextabledebug}>
										<table className={classes.itemtable}>
											<tbody>
												{/* <tr>
													<td style={{ width: "160px", paddingTop: "8px" }}>
														SomeBoolean:
													</td>
													<td style={{ verticalAlign: "bottom", paddingBottom: "4px" }}>
														<Checkbox
															className={localstate.itemdiffs.SomeBoolean.dirty ? " " + classes.unsavedhighlight : ""}
															disabled
															checked={(localstate.itemdata.SomeBoolean === 1 ? true : false)}
															onClick={(event) => onChangeValue(event, "SomeBoolean")} />
													</td>
												</tr> */}
											</tbody>
										</table>
									</div>
								</Grid>
							</Grid>
						</Typography>
					}
				</div>
			}
		</LocalizationProvider>
	)
}

export default ComponentView;
